import { useQuery } from '@tanstack/react-query';

import useCurrentBrand from '~/hooks/useCurrentBrand';

import { getAgency } from '~/services/AgentHub/AgentService';

export const agencyQueryKeys = {
  all: ['agency'] as const,
  details: () => [...agencyQueryKeys.all, 'detail'] as const,
  detail: (id: string, brand: string) => [...agencyQueryKeys.details(), id, brand] as const,
};

interface UseGetAgencyOptions {
  enabled?: boolean;
}

export function useGetAgency(id: string, options: UseGetAgencyOptions = {}) {
  const { enabled = true } = options;
  const brand = useCurrentBrand();
  return useQuery({
    queryKey: agencyQueryKeys.detail(id, brand),
    queryFn: async () => {
      return await getAgency(id, brand);
    },
    enabled: enabled && !!id,
  });
}
